/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PayDivision {
    DoNotUse = 1,
    Driver = 2,
    Company = 3,
}
